<template>
    <div class="coffee-sort-wrapper" v-click-outside="close">
        <div @click="open = !open" class="sort-main-btn" :class="{'shadowed': open}">
            <font-awesome-icon :icon="chevronIcon" />
            <span>Sort</span>
        </div>

        <transition-expand>
            <div v-if="open" class="sort-item-list" :class="{'shadowed': open}">
                <div v-for="item in SORT_ITEMS" @click="selectItem(item)" class="sort-item" :class="{ 'active-sort-item': (selectedItem && selectedItem.param === item.param) }">
                    {{ item.name }}
                </div>
            </div>
        </transition-expand>

        <div v-if="selectedItem">
            <div  @click="selectItem(selectedItem)" class="sort-pill">
                {{ selectedItem.name }} <span class="remove-cross">x</span>
            </div>
            <div  @click="selectItem(selectedItem)" class="sort-clear-pill">
                Clear
            </div>
        </div>

    </div>
</template>

<script>
    import { ClickOutside }from '../../directives/click-outside'
    import TransitionExpand from '../transition-expand';
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

    export default {
        name: "coffee-sort",
        directives: {
            ClickOutside
        },
        components: {
            TransitionExpand,
            library,
            faChevronUp,
            faChevronDown,
            FontAwesomeIcon
        },
        props: {
            includePriceSort: {
                type: Boolean,
                default: false
            },
            defaultOption: {
                type: String,
                default: null
            },
            forWorkplace: Boolean,
        },
        data: function () {
            return {
                open: false,
                selectedItem: undefined
            }
        },
        methods: {
            close() {
              this.open = false;
            },
            selectItem(item) {
                if (!this.selectedItem) {
                    this.selectedItem = item;
                } else {
                    this.selectedItem = (this.selectedItem.param === item.param) ? undefined : item;
                }
                setTimeout( () => {
                    this.open = false;
                }, 500);

                this.$emit('paramUpdated', this.selectedItem && this.selectedItem.param);
            }
        },
        computed: {
            chevronIcon () {
                return this.open ? faChevronUp : faChevronDown;
            }
        },
        created () {
            this.SORT_ITEMS = [];

            if (this.forWorkplace) {
                this.SORT_ITEMS.push(
                    {
                        name: 'Top requested',
                        param: 'num_requests'
                    }
                )
            }

            this.SORT_ITEMS.push(
                {
                    name: 'Most Popular',
                    param: 'popularity'
                },
                {
                    name: 'Newest',
                    param: 'created_at_desc'
                },
                {
                    name: 'Name (A-Z)',
                    param: 'coffee_name_asc'
                },
                {
                    name: 'Name (Z-A)',
                    param: 'coffee_name_desc'
                },
                {
                    name: 'Roaster (A-Z)',
                    param: 'roaster_name_asc'
                },
                {
                    name: 'Roaster (Z-A)',
                    param: 'roaster_name_desc'
                }
            );

            if (this.includePriceSort) {
                this.SORT_ITEMS.push({
                    name: 'Price (Low-High)',
                    param: 'price_asc'
                });

                this.SORT_ITEMS.push({
                    name: 'Price (High-Low)',
                    param: 'price_desc'
                });
            }
        },
        mounted () {
            if (this.defaultOption === 'topRequested') {
                this.selectItem(this.SORT_ITEMS.find(i => i.param === 'num_requests'));
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/variables_workplace";
    $space-size: 0.5rem;
    $black: #18262D;
    $pink: #F2E5E9;;
    $shadow: 0 1px 3px -1px rgba(0,0,0,0.75);

    .coffee-sort-wrapper {
        position: relative;
    }
    .sort-main-btn {
        padding: 0.75rem 1.5rem;
        background-color: $color-primary-dark;
        color: white;
        cursor: pointer;
        &:hover {
            background-color: darken($color-primary-dark, 5%);
        }
        svg {
            font-size: 11px;
            margin-right: 8px;
        }
    }
    .sort-item-list {
        overflow: hidden;
        position: absolute;
        left: 0;
        width: 100%;
        z-index: 1;
        background-color: $white;
    }
    .shadowed {
        -webkit-box-shadow: $shadow;
        -moz-box-shadow: $shadow;
        box-shadow: $shadow;
    }
    .sort-item {
        margin-top: $space-size;
        padding: 1rem 1.5rem;
        color: $black;
        background-color: $pink;
        cursor: pointer;
        &:hover {
            background-color: darken($pink, 5%);
        }
    }
    .active-sort-item {
        background-color: darken($pink, 10%);
    }
    .pill {
        display: inline-block;
        margin-top: 6px;
        padding: 1px 0.5rem;
        font-size: 12px;
        border: 1px solid $color-primary-dark;
        white-space: nowrap;
        cursor: pointer;
    }
    .sort-pill {
        @extend .pill;
        color: $white;
        background-color: $color-primary-dark;
        &:hover {
            background-color: lighten($color-primary-dark, 10%);
        }
    }
    .remove-cross {
        padding-left: 0.5rem;
    }
    .sort-clear-pill {
        @extend .pill;
        color: $color-primary-dark;
        background-color: $white;
        &:hover {
            color: darken($color-primary-dark, 20%);
            border-color: darken($color-primary-dark, 20%);
        }
    }

    @media only screen and (max-width: $max-tablet-width) {
        .sort-pill-wrapper {
            padding-left: 6px;
            padding-bottom: 4px;
        }
        .sort-item-list {
            width: 100vw;
            margin-left: -100%;
        }
    }
</style>
